module.exports = __webpack_public_path__ + "media/Components/fonts/LobsterTwoitalic-40090f4aadc1f04a4df6a402bbfacfc4.ttf";